import React, { useState, useEffect } from 'react'
import DataGrid from '../../../../components/DataGrid'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { Alterar, Excluir, Visualizar } from '../../../../components/Acoes'
import { getApi } from '../../../../util/Configuracoes'
import { excluir } from '../../../../util/FuncoesComuns'
import { HeaderCadastro } from '../../../../components/Headers'
import { consultar } from '../../../../util/AcessoApi'

const ConsultaGrupoEscala = (props) => {
    const [data, setData] = useState([])
    useEffect(() => {
        consultar('/administracao/grupo-escala', (dados) => setData(dados))
    }, [])

    const columns = React.useMemo(
        () => [ 
            {
                id: 'consulta-empresa',
                columns: [
                    {
                        Header: 'Código',
                        accessor: 'id',
                        ordenamento: {
                            tipo: 'numero',
                            ativo: true,
                            modo: 'desc',
                        }
                    },
                    {
                        Header: 'Descrição',
                        accessor: 'descricao_grupo',
                        ordenamento: {
                            tipo: 'texto'
                        }
                    },
                    {
                        Header: 'Sócios',
                        accessor: 'siglas',
                        ordenamento: {
                            tipo: 'texto'
                        },
                        filtro: {
                            tipo: 'socio_equipe',
                            idColuna: 'socio.ID'
                        }
                    },
                    {
                        Header: 'Data Registro',
                        accessor: 'data_registro',
                        ordenamento: {
                            tipo: 'texto'
                        },
                        filtro: {
                            tipo: 'data',
                            idColuna: "data_registro",
                            datePicker: true,
                            date: true
                        }
                    }
                ],
            },
        ],
        []
    )

    const acoesObj = [
        (props) => <Visualizar to={'/administracao/grupo-escala/visualizacao/' + props.id} />,
        (props) => <Alterar to={'/administracao/grupo-escala/alteracao/' + props.id} />,
        (props) => <Excluir to={'/administracao/grupo-escala/consulta/'} action={() => excluir(props.id, setData, '/GrupoEscala/excluir', '/GrupoEscala')} />
    ]

    const caminho = {
        cadastro: '/administracao/grupo-escala/cadastro',
    }

    return (
        <>
            <div>
                <DataGridAlternativa
                    data={data}
                    columns={columns}
                    setData={setData}
                    caminhoBase='/administracao/grupo-escala'
                    caminhoConsultaFiltros= '/administracao/grupoescalapaginacao'
                    acoes={true}
                    url={{ cadastro: '/administracao/grupo-escala/cadastro', }}
                    modulo={props.modulo}
                    titulo={'Consulta Grupo Escala'}
                    urlCadastro='/administracao/grupo-escala/cadastro' 
                    icone ={'icon-Mens'}/>
            </div>
        </>
    )
}

export default ConsultaGrupoEscala